import Table from '../../../form/component/Table'
import { formatMoney } from '../../../../util/money'
import { BANK_PAYMENT_TEXT } from '../../state/const'

export const columnList = [
    {
        property: 'date',
        header: 'Created',
        comparator: Table.dateComparator('date'),
        renderer: Table.dateRenderer('date'),
    },
    {
        property: 'amount',
        header: 'Amount',
        renderer: (payment) => {
            return formatMoney(payment.amount, payment.currency)
        },
    },
    {
        property: 'type',
        header: 'Type',
        renderer: (payment) => {
            if(!payment.bankPayment) {
                return ''
            }
            return BANK_PAYMENT_TEXT[payment.bankPayment.type]
        },
    },
    {
        property: 'reference',
        header: 'Reference',
        renderer: (payment) => {
            if(!payment.bankPayment) {
                return ''
            }
            return payment.bankPayment.reference
        },
    },
    {
        property: 'customer_reference',
        header: 'Customer Reference',
        renderer: (payment) => {
            if(!payment.bankPayment) {
                return ''
            }
            return payment.bankPayment.customerReference
        },
    },
    {
        property: 'sender',
        header: 'Sender',
        renderer: (payment) => {
            if(!payment.bankPayment) {
                return ''
            }
            return payment.bankPayment.otherParty
        },
    },
    {
        property: 'note',
        header: 'Note',
        renderer: (payment) => {
            if(!payment.bankPayment) {
                return ''
            }
            return payment.bankPayment.note
        },
    },
]



// WEBPACK FOOTER //
// ./src/modules/payment/component/associate-payment/column-list.js